import { signal } from '@preact/signals';

const KEY = 'ct:submitPrefill:v1';

/** A PEM chain handed from an entry page to the Submit page ("submit this to other logs"). */
export const submitPrefill = signal<string>((() => {
  try {
    return sessionStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
})());

export function setSubmitPrefill(pem: string): void {
  submitPrefill.value = pem;
  try {
    sessionStorage.setItem(KEY, pem);
  } catch {
    /* unavailable */
  }
}

export function takeSubmitPrefill(): string {
  const v = submitPrefill.value;
  if (v) setSubmitPrefill('');
  return v;
}
